import { useRef } from 'react';
import { Transition } from 'react-transition-group';
import { jsx } from 'react/jsx-runtime';

/**
 * custom Transtion component for react-transition-group similar to the
 * CSSTransition, however with a slightly altered API to improve DX.
 *
 * After the introduction of ReactStrictMode react-transition-group transitions
 * needs to be provided with a nodeRef prop to not use findDOMNode() which may
 * have a negative impact on performance.
 *
 * However, manually passing refs may become cumbersome to provide. Thus, this
 * transition aims to easy the API required to make Transitions for
 * react-transition-groups by provided all props required for children as
 * arguments.
 */
function RefTransition(transitionProps) {
  const internalRef = useRef(null);
  const nodeRef = transitionProps.nodeRef ?? internalRef;
  return /*#__PURE__*/jsx(Transition, {
    ...transitionProps,
    nodeRef: nodeRef,
    children: transitionProps.children(nodeRef)
  });
}

export { RefTransition };
//# sourceMappingURL=transition.base.js.map
